import React from "react";
import Box from "@material-ui/core/Box";
import { Container } from "@prestosports/commons-ui";
import GameFinalize from "../components/GameFinalize";
import GameHeader from "../components/GameHeader";
import commonStyles from "../../common/styles/Common.styles";
import { useTeamsContext } from "../../../state/teams/context";
import { useGameContextContext } from "../../../state/game-context/context";
import { GameRoutes } from "../../../routes/game-routes";
import { useAppContext } from "../../../state/app/context";
import { useEventContext } from "../../../state/events/context";
import { usePlayersFootballContext } from "../../../state/players/football-context";

const GameFinalizeContainer = () => {
	const commonClasses = commonStyles();

	const { state: teamState } = useTeamsContext();
	const homeTeam = teamState.homeTeam();
	const awayTeam = teamState.awayTeam();

	const { state: awayPlayersContextState } = usePlayersFootballContext({
		team: awayTeam
	});
	const awayParticipatingPlayers =
		awayPlayersContextState.participatingPlayers();

	const { state: homePlayersContextState } = usePlayersFootballContext({
		team: homeTeam
	});
	const homeParticipatingPlayers =
		homePlayersContextState.participatingPlayers();

	const {
		state: gameContextState,
		finalizeGame,
		saveFinalizationSettings
	} = useGameContextContext();
	const finalizeSettings = gameContextState.finalizeSettings();
	const isGameTimeOver = gameContextState.isGameTimeOver();

	const { redirect } = useAppContext();

	const { state: eventState } = useEventContext();
	const currentEvent = eventState.currentEvent();
	const currentEventSettings = eventState.currentEventSettings();

	const cancel = () => {
		redirect(GameRoutes.GAME_MODE.url.replace(":eventId", currentEvent.id));
	};

	return (
		<>
			<GameHeader
				title="Finalize Event"
				description="Enter the final details of the event."
			/>
			<Box className={commonClasses.infoContainer}>
				{homeTeam && awayTeam && (
					<Container fullHeight>
						<GameFinalize
							homeTeam={homeTeam}
							awayTeam={awayTeam}
							settings={finalizeSettings}
							isGameTimeOver={isGameTimeOver}
							event={currentEvent}
							onFinalize={finalizeGame}
							onSave={saveFinalizationSettings}
							onCancel={cancel}
							currentEventSettings={currentEventSettings}
							homeParticipatingPlayers={homeParticipatingPlayers}
							awayParticipatingPlayers={awayParticipatingPlayers}
						/>
					</Container>
				)}
			</Box>
		</>
	);
};
export default GameFinalizeContainer;
